import React from 'react';

import {Link} from 'react-router-dom';

function Menu() {
    return (
        <nav className="dropdownmenu">
            <ul>
                <li>
                    <Link className="nav_link" to="/contest" target="_self">
                        Contest
                    </Link>
                </li>
                <li>
                    <Link className="nav_link" to="/leaderboard">
                        Leaderboard
                    </Link>
                </li>
                <li>
                    <a className="nav_link" href="/documentation/en/user_guide/data.html" target="_self">
                        Data
                    </a>
                </li>
                <li>
                    <a className="nav_link" href="/documentation/en/" target="_self">
                        Docs
                    </a>
                </li>
                <li>
                    <a
                        className="nav_link quantiacs_community_link"
                        target="_self"
                        href="/community"
                    >
                        Community
                    </a>
                </li>
            </ul>
        </nav>
    );
}

export default Menu;
